module.exports = __webpack_public_path__ + "media/global_smart_banner/gsb-close-icon-f704d531.svg";